module.exports = "/static/img/who_we_are_bg.png?32e555939db98070784c419a7a08fe1d";